// extracted by mini-css-extract-plugin
export var spacingGrid = "SpacingField-module--spacingGrid--94840";
export var spacingGridInputs = "SpacingField-module--spacingGridInputs--26115";
export var spacingGridTitle = "SpacingField-module--spacingGridTitle--10657";
export var spacingInput = "SpacingField-module--spacingInput--e828a";
export var spacingInputField = "SpacingField-module--spacingInputField--11bb3";
export var spacingInputLabel = "SpacingField-module--spacingInputLabel--8339c";